import React from 'react';
import {Provider} from "react-redux";

import RewardCompleteContainer from "./container/RewardCompleteContainer";

import configure from '../../store/configure';

const RewardCompletePage = () => {

    const searchParams = new URLSearchParams(window.location.search);

    const code = searchParams.get("code");
    const state = searchParams.get("state");

    return (
        <Provider store={configure}>
            <RewardCompleteContainer
                code={code}
                state={state}
            />
        </Provider>
    );
};

export default RewardCompletePage;
